import { FormControl, FormControlLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import { NormalizedPaymentAssets, TokenId } from 'entities/payment/model';
import { COLOR_BG_SECONDARY, TokenFormat } from 'shared';

interface DebitTokenSelectorProps {
  packageName: string;
  options: Record<string, number>;
  tokens: NormalizedPaymentAssets['tokens'];
  selected: TokenId | undefined;
  onSelect: (tokenId: TokenId) => void;
  networks: NormalizedPaymentAssets['networks'];
}

export const DebitTokenSelector = ({
  packageName,
  options,
  networks,
  tokens,
  selected,
  onSelect,
}: DebitTokenSelectorProps) => {
  return (
    <Stack width="100%" bgcolor={COLOR_BG_SECONDARY} borderRadius={3} p={1.5} mb={1}>
      <Typography variant="body2" className="secondary" mb={1}>
        To purchase{' '}
        <Typography component="span" variant="body2" className="accent">
          {packageName} package
        </Typography>{' '}
        you will be buying:
      </Typography>

      <FormControl sx={{ mb: 1 }}>
        <RadioGroup onChange={(_, value) => onSelect(value)} color="secondary">
          {Object.entries(options).map(([tokenId, tokenValue]) => {
            const _token = tokens.byId[tokenId];
            const _network = networks.byId[_token.networkId];
            return (
              <FormControlLabel
                key={tokenId}
                value={tokenId}
                control={
                  <Radio
                    sx={{
                      '& .MuiSvgIcon-root': {
                        width: `24px`,
                      },
                    }}
                  />
                }
                label={
                  <TokenFormat
                    approx
                    amount={tokenValue.toString()}
                    symbol={`${_token.symbol} (${_network.shortName})`}
                    maxDecimalDigits={_token.decimals}
                    decimals={_token.decimals}
                    maxTotalLength={18}
                    adaptiveDecimals
                    variant="body2"
                    className={selected === tokenId ? 'primary' : 'secondary'}
                  />
                }
                sx={{ height: 36 }}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    </Stack>
  );
};
